import service from "./service";
import {Message} from "element-ui";
import router from '@/router'

export const httpPost = (url, param) => {
    //console.log(url, param)
    url = window.host.ProjectUrl + url;
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        if(param){
            Object.keys(param).forEach((key) => {
                // if(Array.isArray(param[key])){
                //     for(let i in param[key]){
                //         formData.append(key, param[key][i]);
                //     }
                // }else{
                    formData.append(key, param[key]);
                // }
            });
        }
        service.post(url, formData,{headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(res => {
            if (res.data.infoCode != "0") {
                let msg = "error";

                msg = window.retMsg[res.data.infoCode];
                let infoDescribe=res.data.infoDescribe;
                if(res.data.infoCode === "1") {
                    if (infoDescribe != undefined && infoDescribe != null && infoDescribe != '') {
                        msg = infoDescribe
                    }
                }
                Message.error(msg);
            }
            if(res.data.result && res.data.result == "exception"){
                Message.error(res.data.exception);
            }

            if(res.data.infoCode == "10"){
                router.push({path: '/login'})
            }
            resolve(res.data)
        }).catch(err => {
            resolve(err)
        })
    })
}

export const filePost = (url, param) => {
    url = window.host.ProjectUrl + url;
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        if(param){
            Object.keys(param).forEach((key) => {
                formData.append(key, param[key]);
            });
        }
        service.post(url, formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
            console.log(res)
            resolve(res.data)
        }).catch(err => {
            resolve(err)
        })
    })
}